import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { useNavigate } from "react-router-dom";

/**
 * 人材カード右上のメニュー（希望条件・スキルシート詳細など）
 */
const CandidateMenu = ({ candidate, tabType }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleOpenMenu = (event) => setAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setAnchorEl(null);

  // 遷移先を決定
  const handleCardClick = () => {
    if (tabType === "project") {
      navigate(`/company/candidates/${candidate.id}/contract_request`);
    } else if (tabType === "job") {
      navigate(`/company/candidates/${candidate.id}/job_request`);
    }
  };

  // スキルシート詳細リンク用（fromパラメータ付与）
  const handleSkillSheetClick = () => {
    if (tabType === "project") {
      window.location.href = `/company/candidates/${candidate.id}/skill_sheet?from=contract_request`;
    } else if (tabType === "job") {
      window.location.href = `/company/candidates/${candidate.id}/skill_sheet?from=job_request`;
    }
  };

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleOpenMenu(e);
        }}
        size="small"
        sx={{ p: 0.5 }}
      >
        <MoreHorizIcon />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={(event, reason) => {
          if (event?.stopPropagation) event.stopPropagation();
          handleCloseMenu();
        }}
      >
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleCloseMenu();
            handleCardClick();
          }}
        >
          希望条件を見る
        </MenuItem>
        <MenuItem
          onClick={(e) => {
            e.stopPropagation();
            handleCloseMenu();
            handleSkillSheetClick();
          }}
        >
          スキルシート詳細を見る
        </MenuItem>
      </Menu>
    </>
  );
};

export default CandidateMenu;
